import { config } from './config';
import createApiError, { ApiError } from './createApiError';

type Method = 'POST' | 'PUT';

export type ApiCallOptions = {
  method?: Method;
  endpoint: string;
  payload?: any;
};

const callMiddlewareApi = async <T = any>({ ...options }: ApiCallOptions): Promise<T> => {
  const { method, endpoint, payload } = options;
  const headers: Record<string, string> = {
    'X-Shop-ID': config.appId.toString()
  };

  const url = `https://${config.environment}-ingrid.addon.scayle.cloud${endpoint}`;

  if (config.session.accessToken) {
    headers.Authorization = `Bearer ${config.session.accessToken}`;
  }

  let fetchOptions: RequestInit = { headers, method };
  if (payload) {
    headers['Content-Type'] = 'application/json';
    fetchOptions = { ...fetchOptions, body: JSON.stringify(payload), method: fetchOptions.method ?? 'POST' };
  }

  const response = await fetch(url, fetchOptions);

  if (response.status === 401) {
    throw new ApiError('401 (Unauthorized) received - Reloading page...', response.status);
  } else if (response.status >= 400) {
    throw await createApiError(response);
  } else {
    return response.json();
  }
};

export default callMiddlewareApi;
